import { gql } from '@apollo/client';

export const ATTACHMENT = gql`
  query Attachment($id: ID!) {
    attachment(id: $id) {
      id
      filename
      contentType
      url
    }
  }
`

export const UPLOAD_ATTACHMENT = gql`
  mutation UploadAttachment(
    $recordType: String!
    $recordId: ID!
    $name: String!
    $file: Upload!
    $primary: Boolean
  ) {
      uploadAttachment(
        recordType: $recordType
        recordId: $recordId
        name: $name
        file: $file
        primary: $primary
    ) {
      attachment {
        id
        filename
        url
      }
    }
  }
`;

export const REMOVE_ATTACHMENT = gql`
  mutation RemoveAttachment(
    $id: ID!
  ) {
      removeAttachment(
        id: $id
    ) {
      attachment {
        id
      }
    }
  }
`;

export const MAKE_PRIMARY_ATTACHMENT = gql`
  mutation MakePrimaryAttachment(
    $id: ID!
  ) {
      makePrimaryAttachment(
        id: $id
    ) {
      attachment {
        id
      }
    }
  }
`;

export const CREATE_LINKED_ATTACHMENT = gql`
  mutation CreateLinedAttachment(
    $ownerId: ID
    $ownerType: String
    $name: String
    $url: String
  ) {
    createLinkedAttachment(
      ownerId: $ownerId
      ownerType: $ownerType
      name: $name
      url: $url
    ) {
      linkedAttachment {
        id
        ownerId
        ownerType
        resourceType
        name
        url
      }
    }
  }
`;

export const UPDATE_LINKED_ATTACHMENT = gql`
  mutation UpdateBuyer(
    $id: ID!
    $ownerId: ID
    $ownerType: String
    $name: String
    $url: String
  ) {
    updateBuyer(
      id: $id
      ownerId: $ownerId
      ownerType: $ownerType
      name: $name
      url: $url
    ) {
      linkedAttachment {
        id
        ownerId
        ownerType
        resourceType
        name
        url
      }
    }
  }
`;

